import React from 'react';
import { UserPermissionContainer } from '@its/components/lib/Container components/UserContainer/UserPermissionContainer';
import BaseStepper from '@its/components/lib/Container components/StepperContainer/BaseStepper';
import {
  developer,
  admin,
} from '@its/components/lib/Container components/UserContainer/roles';
import {
  CreateTimer,
  CreateTemplate,
  CreateDisplay,
  CreateTimerDescription,
  CreateTemplateDescription,
  CreateDisplayDescription,
  CanCreateDisplay,
  HelpIntroduction,
} from '../../i18n/intl';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.stepper = {
      appBar: {
        title: 'HELP',
        navigateBack: false,
      },
      finishMessage: CanCreateDisplay,
      steps: [{
        title: CreateTimer,
        message: CreateTimerDescription,
      }, {
        title: CreateTemplate,
        message: CreateTemplateDescription,
      }, {
        title: CreateDisplay,
        message: CreateDisplayDescription,
      }],
    };
  }

  render() {
    return (
      <UserPermissionContainer
        allowedRoles={[developer, admin]}
        showError
      >
        <div>
          <div style={ { margin: 30 } }>
            {HelpIntroduction}
          </div>
          <BaseStepper
            {...this.stepper}
          />
        </div>
      </UserPermissionContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Util/Help.js
 **/